export enum PathKeys {
  ROOT = "/",
  LOADING_APP = "/loading-app",
  PROFILE = "/profile",
  EDIT_PROFILE = "/profile/edit",
  CHANGE_PASSWORD = "/profile/change-password",

  SALES = "/sales",
  TRACC_USAGE = "/sales/tracc-usage",

  MANAGEMENT = "/management",
  USERS = "/management/users",
  API_ACCOUNTS = "/management/apiAccounts",
  ORGANISATIONS = "/management/organisations",
  BILLED_OPERATIONS = "/management/billedoperations",
  BILLED_OPERATION_SUMMARY = "/management/billedoperationssummary",
  BANNED_IP = "/management/bannedIP",
  LICENCES = "/management/licences",
  PRODUCT_LICENCES = "/management/products-licences",
  LICENCE_TYPES = "/management/licence-types/:softwareName",
  PRICING = "/management/licence-types/:softwareName/:licenceType/pricing",
  ORDERS = "/management/orders",

  AUTH_ROOT = "/auth",
  SIGN_IN = "/auth/signin",
  SIGN_UP = "/auth/signup",
  FORGOT_PASSWORD = "/auth/forgot-password",
  RESET_PASSWORD = "/auth/reset-password",

  EMAIL_CONFIRMATION = "/ConfirmEmail",
  DECLINE_RESET_PASSWORD = "/rejectResetPassword",

  PURCHASE_LICENCE = "/purchase-licence",

  PAYMENT = "/payment",
  RETURN = "/return",

  TRACC = "/tracc",
  TRACC_WEB_MAP_PURCHASE = "/tracc/purchase/tracc-web-map",
}
